export default {
    formId: "NewAffinityForm",
    formField: {
        business_unit: {
            name: 'business_unit',
            label: 'Unidad de negocio*',
            requiredErrorMsg: 'Por favor, seleccione la UN a la que pertenece la afinidad'
        },
        commercial_condition: {
            name: 'commercial_condition',
            label: 'Condiciones particulares*',
            requiredErrorMsg: 'Por favor, seleccione una opción'
        },
        commercial_description: {
            name: 'commercial_description',
            label: 'Descripción*',
            requiredErrorMsg: 'Por favor, complete el campo'
        },
        giftcard_amount: {
            name: 'giftcard_amount',
            label: 'Monto de Gift Card*',
            requiredErrorMsg: 'Por favor, indique un valor'
        },
        extra_discount: {
            name: 'extra_discount',
            label: 'Descuento Especial*',
            requiredErrorMsg: 'Por favor, ingrese el descuento extra máximo'
        },
        adviser_phone: {
            name: 'adviser_phone',
            label: 'Celular del asesor*',
            requiredErrorMsg: 'Por favor, ingrese el celular del asesor a cargo de la afinidad'
        },
        model_discount: {
            name: 'model_discount',
            label: 'Descuento Extra*',
            requiredErrorMsg: 'Por favor, ingrese el descuento por modelo máximo'
        },
        company_name: {
            name: 'company_name',
            label: 'Nombre de la empresa*',
            requiredErrorMsg: 'Por favor, ingrese el nombre de la empresa'
        },
        business_name: {
            name: 'business_name',
            label: 'Razón social*',
            requiredErrorMsg: 'Por favor, ingrese la razón social de la empresa'
        },
        company_logo: {
            name: 'company_logo',
            label: 'Logo*',
            requiredErrorMsg: 'Por favor, cargue el logo de la empresa'
        },
        intermediary_code: {
            name: 'intermediary_code',
            label: 'Código de intermediario*',
            requiredErrorMsg: 'Por favor, ingrese el código de intermediario'
        },
        organizer_code: {
            name: 'organizer_code',
            label: 'Código de organizador*',
            requiredErrorMsg: 'Por favor, ingrese el código de organizador'
        },
        assigned_advisers: {
            name: 'assigned_advisers',
            label: 'Asesores asignados',
            requiredErrorMsg: 'Por favor, seleccione al menos un asesor a cargo de la afinidad'
        },
        managerAffinity_mail: {
            name: 'managerAffinity_mail',
            label: 'Email del responsable*',
            requiredErrorMsg: 'Por favor, ingrese el email del responsable de la afinidad',
            invalidErrorMsg: 'Email inválido'
        },
        managerAffinity_name: {
            name: 'managerAffinity_name',
            label: 'Nombre del responsable*',
            requiredErrorMsg: 'Por favor, ingrese el nombre del responsable de la afinidad',
        },
        managerAffinity_lastName: {
            name: 'managerAffinity_lastName',
            label: 'Apellido del responsable*',
            requiredErrorMsg: 'Por favor, ingrese el apellido del responsable de la afinidad',
        },
        managerAffinity_phone: {
            name: 'managerAffinity_phone',
            label: 'Celular del responsable*',
            requiredErrorMsg: 'Por favor, ingrese el celular del responsable de la afinidad',
            invalidErrorMsg: 'Celular inválido'
        },
        activated_products: {
            name: 'activated_products',
            label: 'Productos habilitados*',
            requiredErrorMsg: 'Por favor, seleccione al menos un producto',
        },
        statistic_group: {
            name: 'statistic_group',
            label: 'Grupo estadístico*',
            requiredErrorMsg: 'Debe ingresar un valor',
        }
    },
};
